export function predicateForSessionStartsInInterval(window) {
    const start = Number(window.start);
    const end = Number(window.end);
    function predicate(event) {
        const sessionStartTimes = event.sessions.map((session) => Number(session.startTime.format('military')));
        for (const time of sessionStartTimes) {
            // The end-time of the session does not matter.
            // TODO Consider supporting some padding, perhaps via metadata config.
            if (start <= time && time < end) {
                return true;
            }
        }
        return false;
    }
    return predicate;
}
